/**
 * DAVMAN AI INTEGRATION
 * Este archivo es parte de la integración personalizada de IA para Davman Persa.
 * NO es parte del código original de Chatwoot.
 *
 * Rutas del panel de administración de Davman AI
 */

import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import DavmanAiSettings from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/davman-ai'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'davman_ai_settings', params: to.params };
          },
        },
        {
          path: 'settings',
          name: 'davman_ai_settings',
          component: DavmanAiSettings,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
